module.exports = __webpack_public_path__ + "img/Turkey.b26029c0.gif";